import dayjs from 'dayjs';

function pad2(n: number): string {
	return String(n).padStart(2, '0');
}

function toUtcYmd(date: Date): string {
	const y = date.getUTCFullYear();
	const m = pad2(date.getUTCMonth() + 1);
	const d = pad2(date.getUTCDate());
	return `${y}-${m}-${d}`;
}

export function toUtcIsoStartOfDay(date: Date): string {
	return `${toUtcYmd(date)}T00:00:00Z`;
}

export function toUtcIsoEndOfDay(date: Date): string {
	return `${toUtcYmd(date)}T23:59:59.999Z`;
}

export function formatAuditRevType(revType: number | undefined): string {
	if (revType === 0) {
		return 'Create';
	}
	if (revType === 1) {
		return 'Update';
	}
	if (revType === 2) {
		return 'Delete';
	}
	if (revType === undefined) {
		return '—';
	}
	return String(revType);
}

export function formatAuditChangedAt(iso: string): string {
	if (!iso) {
		return iso;
	}
	const parsed = dayjs(iso);
	if (!parsed.isValid()) {
		return iso;
	}
	return parsed.format('MMM D, YYYY, HH:mm:ss');
}
